// extracted by mini-css-extract-plugin
export default {"modal":"Uba","heading":"Vba","product":"Wba","note":"Xba","notetitle":"Yba","notetext":"Zba","line":"aca","plan":"bca","planimage":"cca","description":"eca"};
    if(module.hot) {
      // 1714442371914
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  